import { render, staticRenderFns } from "./ModelFacade.vue?vue&type=template&id=40eb0c98&scoped=true"
import script from "./ModelFacade.vue?vue&type=script&lang=js"
export * from "./ModelFacade.vue?vue&type=script&lang=js"
import style0 from "./ModelFacade.vue?vue&type=style&index=0&id=40eb0c98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40eb0c98",
  null
  
)

export default component.exports